/**
 * Configuração centralizada de planos, preços e contratação.
 * Altere valores aqui para refletir em toda a página /planos.
 */

export const WHATSAPP_NUMBER = '5511933728770';

export const IMPLANTACAO = {
  /** Por enquanto sem cobrança de implantação no site / checkout. */
  ativo: false,
  valor: 0,
  currency: 'BRL',
  inclui: [
    'Configuração inicial',
    'Conexão do WhatsApp',
    'Configuração dos usuários',
    'Orientação inicial',
    'Apoio para colocar a operação dentro do sistema',
  ],
};

export const PERIODOS_CONTRATACAO = {
  trimestral: {
    id: 'TRIMESTRAL',
    label: 'Trimestral',
    descricao: 'Pagamento dos 3 meses',
    detalhe: 'Pagamento antecipado dos 3 meses pelo valor mensal cheio.',
    meses: 3,
    descontoPercentual: 0,
    implantacaoValor: 0,
    cobrancaAntecipada: true,
  },
  semestral: {
    id: 'SEMESTRAL',
    label: 'Semestral',
    descricao: '10% de desconto',
    detalhe: 'Pagamento antecipado dos 6 meses com 10% de desconto.',
    meses: 6,
    descontoPercentual: 10,
    implantacaoValor: 0,
    cobrancaAntecipada: true,
  },
  anual: {
    id: 'ANUAL',
    label: 'Anual',
    descricao: '15% de desconto',
    detalhe: 'Pagamento antecipado dos 12 meses com 15% de desconto.',
    meses: 12,
    descontoPercentual: 15,
    implantacaoValor: 0,
    cobrancaAntecipada: true,
    badge: 'Melhor custo-benefício',
    destaque: true,
  },
};

export const PROGRAMA_FUNDADORES = {
  ativo: true,
  vagasLimitadas: false,
  vagasRestantes: null,
  whatsappMessage:
    'Olá! Tenho interesse no Programa Fundadores Converlead e gostaria de saber mais sobre as condições especiais.',
};

/** Recursos previstos — habilitar quando estiverem disponíveis em produção */
export const RECURSOS_FUTUROS = {
  metaConversionApi: false,
};

export const PLANOS = [
  {
    id: 'start',
    codigo: 'START',
    nome: 'Start',
    subtitulo: 'Para Studios que querem organizar o comercial',
    precoMensal: 147,
    precoLabel: 'R$ 147/mês',
    destaque: false,
    badge: null,
    cta: 'Começar com o Start',
    checkout: true,
    features: [
      'Módulo Converlead (comercial)',
      '1 unidade',
      '1 WhatsApp conectado',
      '1 usuário',
      'Gestão completa de leads',
      'Funil comercial',
      'Histórico do lead',
      'Origem dos leads',
      'Aulas experimentais',
      'Controle de comparecimento e faltas',
      'Conversões',
      'Registro de perdas e não conversões',
      'Indicadores',
      'Relatórios comerciais',
    ],
  },
  {
    id: 'pro',
    codigo: 'PRO',
    nome: 'Pro',
    subtitulo: 'Para Studios que querem automatizar e converter mais',
    precoMensal: 247,
    precoLabel: 'R$ 247/mês',
    destaque: true,
    badge: 'Mais escolhido',
    cta: 'Quero o Pro',
    checkout: true,
    features: [
      'Tudo do Start',
      'Até 3 usuários',
      '1 unidade',
      '1 WhatsApp',
      'Automações e follow-ups',
      'Integrações avançadas',
      'Integração com o módulo AXYS',
      'Recursos adicionais de inteligência comercial',
    ],
    featuresCondicionais: RECURSOS_FUTUROS.metaConversionApi
      ? [
          {
            texto: 'Integração com Meta para enviar eventos de conversão',
            beneficio: 'Ajude seus anúncios a entender quais leads realmente viram alunos.',
          },
        ]
      : [],
    featuresEmBreve: [
      {
        texto: 'Assistente comercial com IA',
        nota: 'Em evolução — automações inteligentes e consultas comerciais já disponíveis.',
      },
    ],
  },
  {
    id: 'scale',
    codigo: 'SCALE',
    nome: 'Scale',
    subtitulo: 'Para redes e Studios em expansão',
    precoMensal: 397,
    precoLabel: 'A partir de R$ 397/mês',
    destaque: false,
    badge: null,
    cta: 'Falar com um especialista',
    checkout: false,
    notaPreco: 'O valor pode variar conforme quantidade de unidades, WhatsApps e usuários.',
    features: [
      'Tudo do Pro',
      'Múltiplas unidades',
      'Múltiplos WhatsApps',
      '5 usuários ou mais',
      'Dashboard consolidado',
      'Indicadores por unidade',
      'Comparação entre unidades',
      'Gestão de equipes',
      'Gestão de permissões',
      'Visão geral da rede',
      'Suporte prioritário',
    ],
    whatsappMessage:
      'Olá! Tenho interesse no plano Scale do ecossistema Convertrex e gostaria de falar com um especialista.',
  },
];

export const FAQ_ITEMS = [
  {
    pergunta: 'Posso usar apenas o módulo Converlead?',
    resposta:
      'Sim. O Converlead funciona de forma independente para a gestão comercial, dentro do ecossistema Convertrex.',
  },
  {
    pergunta: 'Preciso usar o módulo AXYS?',
    resposta:
      'Não. O AXYS é o módulo operacional do ecossistema e pode ser contratado conforme a necessidade da operação.',
  },
  {
    pergunta: 'Posso integrar os dois sistemas?',
    resposta:
      'Sim. A proposta do ecossistema Convertrex é permitir que o lead acompanhado pelo Converlead siga para a gestão operacional dentro do AXYS após a conversão.',
  },
  {
    pergunta: 'Quantos WhatsApps posso conectar?',
    resposta: 'Depende do plano contratado.',
  },
  {
    pergunta: 'Tenho mais de uma unidade. Qual plano devo escolher?',
    resposta: 'O Scale foi desenvolvido para operações com múltiplas unidades.',
  },
  {
    pergunta: 'Existe implantação?',
    resposta:
      'Sim. Há um processo de configuração e orientação inicial incluso na contratação, sem taxa adicional por enquanto.',
  },
  {
    pergunta: 'Existe treinamento?',
    resposta:
      'Existe orientação inicial para configurar o sistema e preparar a equipe para utilização.',
  },
];

/**
 * Calcula valores de exibição e checkout conforme plano e período.
 *
 * Todos os períodos: pagamento antecipado do bloco (3 / 6 / 12 meses).
 * Semestral −10%, Anual −15%. Implantação desligada por enquanto.
 */
export function calcularValorCheckout(plano, periodoId) {
  const periodo = Object.values(PERIODOS_CONTRATACAO).find((p) => p.id === periodoId);
  if (!plano || !periodo) return null;

  const mensalBase = Number(plano.precoMensal) || 0;
  const desconto = periodo.descontoPercentual / 100;
  const mensalEfetivo = round2(mensalBase * (1 - desconto));
  const valorImplantacao = IMPLANTACAO.ativo
    ? (periodo.implantacaoValor ?? IMPLANTACAO.valor)
    : 0;

  let valorPlano;
  if (periodo.cobrancaAntecipada) {
    valorPlano = round2(mensalBase * periodo.meses * (1 - desconto));
  } else {
    valorPlano = round2(mensalBase);
  }

  return {
    valorMensalBase: round2(mensalBase),
    valorMensalEfetivo: mensalEfetivo,
    valorTotal: round2(valorPlano + valorImplantacao),
    valorPlano,
    valorImplantacao,
    periodo,
  };
}

function round2(valor) {
  return Math.round(valor * 100) / 100;
}

export function formatarMoeda(valor) {
  return valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}

/** Texto principal do preço no card, conforme período selecionado. */
export function rotuloPrecoMensal(plano, calc) {
  if (!plano?.checkout || !calc) {
    return { principal: plano?.precoLabel || '', secundario: null };
  }

  const mensal = formatarMoeda(calc.valorMensalEfetivo);
  if (calc.periodo.descontoPercentual > 0) {
    return {
      principal: `${mensal}/mês`,
      secundario: `de ${formatarMoeda(calc.valorMensalBase)}/mês`,
    };
  }

  return {
    principal: `${mensal}/mês`,
    secundario: null,
  };
}

/** Linha de total / 1ª cobrança abaixo do preço mensal. */
export function rotuloTotalPeriodo(calc) {
  if (!calc) return null;
  const { periodo, valorTotal, valorPlano, valorMensalEfetivo } = calc;

  if (periodo.cobrancaAntecipada) {
    return `Total agora: ${formatarMoeda(valorTotal)} (${formatarMoeda(valorPlano)} pelos ${periodo.meses} meses)`;
  }

  return `1ª cobrança: ${formatarMoeda(valorMensalEfetivo)}`;
}
